import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'


class DataTableBloc {

    rowtableChannel = new Subject();
    rowtableSelectedChannel = new Subject();
    workUnitChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    createChannel = new Subject();
    historyChannel = new Subject();
    riwayatChannel = new Subject();
    positionChannel = new Subject();
    employeeChannel = new Subject();
    delChannel = new Subject();
    prosesChannel = new Subject();
    exportChannel = new Subject();
    exportHistoryChannel = new Subject();
    repository = new DataTableRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.rowtableSelectedChannel.next({status: apiResponse.INITIAL})
        this.workUnitChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.activeChannel.next({status: apiResponse.INITIAL})
        this.createChannel.next({status: apiResponse.INITIAL})
        this.historyChannel.next({status: apiResponse.INITIAL})
        this.riwayatChannel.next({status: apiResponse.INITIAL})
        this.positionChannel.next({status: apiResponse.INITIAL})
        this.employeeChannel.next({status: apiResponse.INITIAL})
        this.delChannel.next({status: apiResponse.INITIAL})
        this.prosesChannel.next({status: apiResponse.INITIAL})
        this.exportChannel.next({status: apiResponse.INITIAL})
        this.exportHistoryChannel.next({status: apiResponse.INITIAL})
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchRowTableSelected = async (query, cancelToken) => {
        try {
            this.rowtableSelectedChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableSelected(query, cancelToken).then((result) => {
                this.rowtableSelectedChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableSelectedChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchRowTableHistory = async (query, cancelToken) => {
        try {
            this.historyChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableHistory(query, cancelToken).then((result) => {
                this.historyChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.historyChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExport = async (query, cancelToken) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport(query, cancelToken).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchExportHistory = async (query, cancelToken) => {
        try {
            this.exportHistoryChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportHistory(query, cancelToken).then((result) => {
                this.exportHistoryChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportHistoryChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchRowTableRiwayat = async (query, cancelToken) => {
        try {
            this.riwayatChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableRiwayat(query, cancelToken).then((result) => {
                this.riwayatChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.riwayatChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }

    fetchActive = async (query) => {
        try {
            this.activeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchActive(query).then((result) => {
                this.activeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.activeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("rxjs", "channel unsubscriber") }
    }
    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchProses = async (query) => {
        this.prosesChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchProses(query).then((result) => {
            this.prosesChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.prosesChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchPosition = async (query) => {
        this.positionChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPosition(query).then((result) => {
            this.positionChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.positionChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchEmployee = async (query) => {
        this.employeeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchEmployee(query).then((result) => {
            this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.employeeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDelMapping = async (query) => {
        this.delChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDelMapping(query).then((result) => {
            this.delChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.delChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default DataTableBloc